import { createTracker } from 'usage-tracker';
import { makeUuid } from 'usage-tracker-core/common/helpers';
let tracker;
export const initUsageTracker = () => {
  if (!tracker) {
    tracker = createTracker({
      standalone: true,
      allowUnauthed: true,
      isExternalHost: true,
      properties: {
        email: null,
        hubId: null,
        lang: null,
        deviceId: makeUuid()
      }
    });
  }
  return tracker;
};
export const trackPageView = subscreen => {
  tracker.track('billing-portal', 'page viewed', {
    subscreen
  });
};